import React from 'react';
/**
 * Builds the description of a notification about missing capabilities. The link is rendered around a part of the
 * text, so that no URL is shown to the user.
 *
 * @param {string} text - The text which describes the missing capabilities.
 * @param {string|undefined} url - A URL with more information, if the server sent one.
 * @param {Function} t - The translation function.
 * @returns {Object} The description properties of the notification.
 */
export function getDescriptionProps(text, url, t) {
    if (!url) {
        return { description: text };
    }
    return {
        description: (React.createElement("span", null,
            `${text} `,
            React.createElement("a", { href: url, rel: 'noopener noreferrer', target: '_blank' }, t('clientRequirements.seeDetails'))))
    };
}
